import { render, staticRenderFns } from "./MarginListEdit.vue?vue&type=template&id=4173bcef&scoped=true"
import script from "./MarginListEdit.vue?vue&type=script&lang=js"
export * from "./MarginListEdit.vue?vue&type=script&lang=js"
import style0 from "./MarginListEdit.vue?vue&type=style&index=0&id=4173bcef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173bcef",
  null
  
)

export default component.exports